/**
Author - Sahil Dhingra
Git - https://github.com/sahildhingra-221
**/

import DematCharges from "./DematCharges";

export default DematCharges;
